import TermCreateEdit from "../AdminTermCreateEdit";

export default class AdminTermCreateEditTimeZone extends TermCreateEdit {
  /**
   * @returns {string} The term type.
   */
  getType() {
    return "time_zone";
  }
}
